import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import FactoryIcon from '@mui/icons-material/Factory';
import { Box, Stack, AppBar, Toolbar, IconButton, Typography, Divider, Grid, Paper } from '@mui/material';
import useResponsive from '../../../hooks/useResponsive';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import logoImage from '../../../media/corporate.png';
import logo from '../../../media/ob.png';
import Iconify from '../../../components/iconify';
//
import AccountPopover from './AccountPopover';
// ----------------------------------------------------------------------

const NAV_WIDTH = 280;
const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar)(({ theme, openNav }) => ({
  boxShadow: 'none',
  ...bgBlur({ color: theme.palette.background.default }),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${openNav ? NAV_WIDTH : 0}px)`, // Adjust width based on sidebar
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme, openNav }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: openNav ? theme.spacing(0, 5) : theme.spacing(0, 8),
    paddingLeft: openNav ? 0 : '50px',
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
  openNav: PropTypes.bool,
};

export default function Header({ onOpenNav, openNav }) {
  const mdUp = useResponsive('up', 'md');

  return (
    <StyledRoot openNav={openNav}>
      <StyledToolbar openNav={openNav}>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'block' },
          }}
        >
          <MenuOpenIcon color="#365486" />
        </IconButton>
        {openNav ? (
          <>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container width={'100%'}>
                <Grid item xs={4} component={Paper} sx={{ backgroundColor: 'inherit', p: 1 }} elevation={0}>
                  <Grid container>
                    <Grid item xs={2} justifyContent={'center'} alignItems={'center'}>
                      <Stack justifyContent={'center'} alignItems={'center'} width={'100%'}>
                        <img
                          src={logoImage}
                          style={{
                            objectFit: 'contain',
                            maxWidth: '50px',
                            marginRight: '20px'
                          }}
                          alt="techveel logo"
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={10} justifyContent={'center'} alignItems={'center'}>
                      <Stack
                        justifyContent={'center'}
                        alignItems={'flex- start'}
                        width={'100%'}
                        height={'100%'}
                        sx={{ borderLeft: '1px solid #C1D8C3' }}
                        pl={2}
                      >
                        <Typography
                          variant="body2"
                          textAlign={'left'}
                          className="font_style_headerer"
                          style={{ textTransform: 'uppercase', color: '#0D7C66' }}
                        >
                          {sessionStorage.getItem('Company_Name')}
                        </Typography>
                        <Typography
                          variant="body2"
                          textAlign={'left'}
                          className="font_style_headerer2"
                          style={{ textTransform: 'uppercase', color: '#7C93C3' }}
                        >                      
                          {sessionStorage.getItem('factoryName')} | {sessionStorage.getItem('FiscalYear')}
                        </Typography>
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={8} />
              </Grid>
            </Box>
          </>
        ) : (
          <Box sx={{ flexGrow: 1 }}>
            
            <Typography
              variant="body2"
              textAlign={'center'}
              gutterBottom
              className={mdUp ? 'font_style2' : 'font_style2sm'}
              style={{ fontWeight: 500,textTransform: 'uppercase', color: '#0D9276' }}
            >
              
              Quick OB
            </Typography>
          </Box>
        )}

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          <AccountPopover />
        </Stack>
      </StyledToolbar>
      {!openNav && <Divider />}
    </StyledRoot>
  );
}
